import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const CtaI2 = ({
  key,
  heading=null,
  solidBackgroundColor="white",
  buttonText=null,
  buttonLink=null,
  buttonOpenNewTab=false,
  sellingPoints=null,
  bottomHeading=null,
  buttomButtonText=null,
  bottomButtonLink=null,
  bottomButtonOpenNewTab=false
}) => {
  return (
    <div className={ `cta_block_i2 pv8 before-${solidBackgroundColor}` }>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-7 offset-lg-2 text-center">
            <div className="bs1">
              <div className="cta-text-top">
                {heading &&
                  <h2 className="ft9 mb4 fwsemibold">{ htmlDecode(heading) }</h2>
                }
                {buttonText && buttonLink &&
                  <div className="row">
                    <div className="col-12 col-lg-7 offset-lg-2">
                      <div className="mb3">
                        <Link href={ buttonLink } target={ `${buttonOpenNewTab ? "_blank" : "_self"}` } className="cta_button">{ buttonText }</Link>
                      </div>
                    </div>
                  </div>
                }
                {sellingPoints &&
                  <p><small id="emailHelp" className="ft4 tcg8">{ htmlDecode(sellingPoints) }</small></p>
                }
              </div>
              {(bottomHeading || buttomButtonText || bottomButtonLink) &&
                <div className="cta-text-bottom">
                  {bottomHeading &&
                    <p className="teaser-header-light tc15">{ bottomHeading }</p>
                  }
                  {(buttomButtonText || bottomButtonLink) &&
                    <Link href={ bottomButtonLink } target={ `${bottomButtonOpenNewTab ? "_blank" : "_self"}` } className="link mv0">{ buttomButtonText }</Link>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CtaI2
